import React from 'react';
import ErrorFormHelper from "../../../../../utils/ErrorFormHelper";
import CitySearchComponent from "../../../../Location/CitySearchComponent";
import ErrorFormView from "../../../../Common/ErrorFormView";
import StreetSearchComponent from "../../../../Location/StreetSearchComponent";
import LocationSearchWithSave from "../../../../Search/LocationSearchWithSave";
import {ConfigAddressApi} from "../../../../../services/Api/types";
import {useTranslation, withTranslation} from "react-i18next";
import {updateSessionLocation} from "../../../../../services/Session/actions";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../../reducers";
import {getSession} from "../../../../../services/Session/reducer";
import ErrorFormAlertView from "../../../../Common/ErrorFormAlertView";
import {getStoreConfig} from "../../../../../services/Store/reducer";

interface OwnProps {
    errors: any[];
    handleInputBlur: (field: string, value?: string) => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartPageDeliverySection = ({
                                     errors,
                                     handleInputBlur,
                                     session,
                                     dispatch,
                                     config
                                 }: Props) => {
    const {t} = useTranslation();
    const address = session.address;
    const isSelectCities = !!config?.ordering.cities_radius;

    const handleChangeAddressValue = (value: any, field: keyof ConfigAddressApi) => {
        let address = {...session.address};
        address[field] = value;
        dispatch(updateSessionLocation(address, true));
    }

    return (
        <div className="card-cart">
            <div className={"container-fluid"}>
                <h5 className={"card-cart-header"}>
                    {t("modules.cart.field.delivery_address.title")}
                </h5>
                <div className={"card-cart-body"}>
                    <div>
                        {
                            !session.in_delivery_area && session.full_address && (
                                <ErrorFormAlertView errors={[t("constraints.internal.store_address_beyond_delivery")]}/>
                            )
                        }
                        <div className="form-row row">
                            {isSelectCities ? (
                                <>
                                    <div
                                        className={`form-group col-lg-4  col-sm-6${address.city ? " focus" : ""}${ErrorFormHelper(errors, "address.city")}`}>
                                        <CitySearchComponent
                                            placeholder={t("common.address.city") + "*"}
                                            className={ErrorFormHelper(errors, "address.city")}
                                            value={address.city}
                                            zip={address.zip_code}
                                            onBlur={(query: any) => handleInputBlur("address.city", query)}
                                            onChange={(value: any) => handleChangeAddressValue(value, "city")}/>
                                        <label htmlFor="city">{t("common.address.city")}</label>
                                        <ErrorFormView errors={errors} field="address.city"/>
                                    </div>
                                    <div
                                        className={`form-group col-lg-4  col-sm-6${address.street ? " focus" : ""}${ErrorFormHelper(errors, "address.street")}`}>
                                        <StreetSearchComponent city={address.city}
                                                               className={ErrorFormHelper(errors, "address.street")}
                                                               placeholder={t("common.address.street") + "*"}
                                                               value={address.street}
                                                               onBlur={(query: any) => handleInputBlur("address.street", query)}
                                                               onChange={(value: any) => handleChangeAddressValue(value, "street")}/>
                                        <label htmlFor="street">{t("common.address.street")}</label>
                                        <ErrorFormView errors={errors}
                                                       field="address.street"/>
                                    </div>
                                </>
                            ) : (
                                <div className="form-group col-lg-8 col-sm-6">
                                    <LocationSearchWithSave/>
                                </div>
                            )}
                            <div className="form-group col-lg-2 col-sm-6">
                                <input type="text" value={address.build_nr}
                                       onChange={(event) => handleChangeAddressValue(event.target.value, "build_nr")}
                                       className={"form-control" + ErrorFormHelper(errors, "address.buildNr")}
                                       id="build_nr"
                                       placeholder={t("common.address.number") + "*"}
                                       onBlur={(event) => handleInputBlur("address.buildNr", event.target.value)}
                                />
                                <label htmlFor="build_nr">{t("common.address.number")}</label>
                                <ErrorFormView errors={errors} field="address.buildNr"/>
                            </div>
                            <div className="form-group col-lg-2  col-sm-6">
                                <input type="text" value={address.flat_nr}
                                       onChange={(event) => handleChangeAddressValue(event.target.value, "flat_nr")}
                                       className={"form-control" + ErrorFormHelper(errors, "address.flat_nr")}
                                       id="flat_nr" placeholder={t("common.address.flat_nr")}
                                       onBlur={(event) => handleInputBlur("address.flat_nr", event.target.value)}
                                />
                                <label htmlFor="flat_nr">{t("common.address.flat_nr")}</label>
                                <ErrorFormView errors={errors} field="address.flat_nr"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPageDeliverySection));
